import React from 'react';
import { Link } from 'react-router-dom';
/** styles,images **/
import s from '../../styles/common/header.module.scss';
import MecLogo from 'assets/images/mec-logo.webp';

export const Header: React.FC = () => {
  return (
    <header>
      <div className={s.inner}>
        <div className={s.logoBlock}>
          <Link to={'/#top'}>
            <p>ペットライフサポート プロジェクト</p>
          </Link>
        </div>

        <div className={s.rightBlock}>
          <a className={s.mecLink} href="https://www.mec.co.jp/" target="_blank" rel="noreferrer">
            <img src={MecLogo} width={150} height={33} alt="三菱地所" />
          </a>
        </div>
      </div>
    </header>
  );
};
